import { APP_STATE } from '../action-types';
import { IRawAppPayload, IStateChange, IAppPayload } from '../types';
import { FeatureFlag } from '../../types';
import { equipmentTypeCorrection } from '../../util/equipment-type-correction';
import { findPlatformType } from '../../util/find-platform-type';
import { GatewayApiClient, setDefaultClient } from '@ifit/gateway-core';
import { formatDate } from '../../util/date-utils';
import { determineSupportsDeepLinksV1 } from '../../util/determine-supports-deeplinks-v1';

export function setAppState(rawPayload: IRawAppPayload): IStateChange<IAppPayload> {
  let value: IRawAppPayload = { ...rawPayload };

  if (typeof value.doEnableScaling === 'string') {
    value = { ...value, doEnableScaling: value.doEnableScaling === 'true' };
  }

  const token = value.token;
  const formattedToken = token ? `Bearer ${token}` : null;
  const baseCacheGatewayApiUrl = value.baseGatewayAPIUrl.replace(/^https:\/\/gateway\./, 'https://gateway-cache.');
  const client = new GatewayApiClient({
    baseURL: value.baseGatewayAPIUrl,
    cacheURL: baseCacheGatewayApiUrl,
    clientId: value.clientId,
    clientSecret: value.clientSecret,
    privateToken: formattedToken,
    nodeProcess: null,
  });

  setDefaultClient(client);

  value.date = formatDate(new Date());

  return {
    type: APP_STATE,
    value: {
      ...value,
      equipmentType: equipmentTypeCorrection(parseInt(value.softwareNumber), value.equipmentType),
      platform: findPlatformType(value.deviceHeight, value.deviceType),
      token,
      clientId: value.clientId,
      clientSecret: value.clientSecret,
      date: value.date,
      language: value.language || 'en',
      baseGatewayAPIUrl: value.baseGatewayAPIUrl,
      isEmbedded: value.isEmbedded,
      appVersion: value.appVersion,
      rawPayload,
      supportsDeepLinksV1: determineSupportsDeepLinksV1(value.appVersion),
      featureFlags: {
        [FeatureFlag.Challenges]: true,
        ...value.featureFlags,
      },
    },
  };
}
